<template>
  <div
    class="musicbox-wrap"
    v-loading="loading.value"
    :element-loading-text="loading.text"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="musicbox-header">
      <span class="state">设备数量: {{ online }}</span>
      <span class="title" @dblclick="screenfullToggle">FCBR-100M首页</span>
      <span class="handler">
        <span v-if="showOpenWindowButton" class="iconfont icon-dakai" @click="openNewWindow"></span>
      </span>
    </div>
    <div class="musicbox-list">
      <el-row
        v-for="(devices, groupName) of deviceGroup"
        :key="groupName"
        :gutter="30"
        type="flex"
        justify="center"
      >
        <el-col v-for="device in devices" :key="device.sn" :span="8">
          <DeviceDetail :sn="device.sn" :deviceData="device" />
        </el-col>
      </el-row>
    </div>
    <AlarmDetail :visible.sync="visible" :data="details" />
  </div>
</template>

<script>
import DeviceDetail from './components/device';
import AlarmDetail from './components/alarm-detail';
import { mapMutations, mapState, mapActions } from 'vuex';
import Type from '@/store/mutation-type';
import ctt from '@/utils/const';
import { windowOpen } from '@/utils/utils';
import screenfull from 'screenfull';

export default {
  components: {
    AlarmDetail,
    DeviceDetail
  },
  sockets: {
    '/socket/detail'(res) {
      this.subDevice(res);
      this.updateData(res);
    }
  },
  provide() {
    return {
      showAlarmPopup: this.showAlarmPopup,
      hideAlarmPopup: this.hideAlarmPopup
    };
  },
  data() {
    return {
      visible: false,
      activeSn: '',
      snList: [],
      deviceList: [],
      deviceGroup: {},
      deviceDataMap: {},
      loading: {
        value: false,
        text: '设备连接中, 请耐心等待'
      }
    };
  },
  computed: {
    ...mapState('socket', ['devicesSourseMap']),
    showOpenWindowButton() {
      return !window.name;
    },
    details() {
      return this.deviceDataMap[this.activeSn] || {};
    },
    online() {
      const total = this.snList.length;
      const online = this.deviceList.filter(e => e.runstate > 0).length;
      return `${online}/${total}`;
    }
  },
  methods: {
    ...mapActions('mqtt', ['subDeviceDetail', 'unsubDeviceDetail']),
    ...mapMutations('socket', {
      subDevice: Type.SUB_DEVICE
    }),
    openNewWindow() {
      windowOpen(this.$route, this.$route.name);
    },
    showAlarmPopup(sn) {
      this.activeSn = sn;
      this.visible = true;
    },
    hideAlarmPopup() {
      this.activeSn = '';
      this.visible = false;
    },
    screenfullToggle() {
      if (screenfull.isFullscreen) {
        screenfull.exit();
      } else {
        screenfull.request(document.getElementById('appContent'));
      }
    },
    showLoading() {
      this.loading.value = true;
    },
    hideLoading() {
      if (!this.loading) return;
      setTimeout(() => {
        this.loading.value = false;
      }, 200);
    },
    subscribeDetail() {
      if (!this.snList.length) return;
      this.subDeviceDetail({ sn: this.snList });
      // this.$socket.emit('/socket/detail', this.snList.join(','));
    },
    unsubscribeDetail() {
      if (!this.snList.length) return;
      this.unsubDeviceDetail({ sn: this.snList });
      // this.$socket.emit('/socket/unsubscribe/detail', this.snList.join(','));
    },
    updateData(res) {
      this.deviceDataMap = Object.assign(this.deviceDataMap, { [res.sn]: res });
    },
    initDeviceGroup() {
      const fcbr100m = [];
      const bm3001 = [];
      this.devicesSourseMap.forEach(e => {
        if (e.deviceType === ctt.FCBR_100M) {
          fcbr100m.push(e);
        } else if (e.deviceType === ctt.B02_V2) {
          bm3001.push(e);
        }
      });
      fcbr100m.sort((a, b) => b.runstate - a.runstate).splice(3);
      bm3001.sort((a, b) => b.runstate - a.runstate).splice(3);
      this.deviceList = fcbr100m.concat(bm3001);
      this.snList = this.deviceList.map(e => e.sn);
      this.deviceGroup['fcbr100m'] = fcbr100m;
      this.deviceGroup['bm3001'] = bm3001;
    }
  },
  created() {
    this.initDeviceGroup();
    this.subscribeDetail();
  },
  beforeDestroy() {
    this.unsubscribeDetail();
    this.hideLoading();
  }
};
</script>

<style lang="scss">
.musicbox-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .musicbox-header {
    color: $primary-text-color;
    margin-bottom: 15px;
    background: url('/static/image/main_header.png');
    height: 60px;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    user-select: none;
    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .state {
      position: absolute;
      font-size: 16px;
      left: 0px;
      top: 8px;
    }
    .handler {
      position: absolute;
      right: 15px;
      top: 5px;
      .icon-dakai {
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .musicbox-list {
    flex: 1;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    .el-row {
      height: 49%;
      margin-bottom: 15px;
      .el-col {
        height: 100%;
      }
    }
  }
}
</style>
